import type { EditableFields } from '@terra/ui-design-system';
import type { PocBlock } from '@terra/shared-schemas-orchestrator';

export function foldPocTextIntoPocBlocks({
  patch,
  currentPocBlocks,
}: {
  patch: Partial<EditableFields>;
  currentPocBlocks: PocBlock[] | null | undefined;
}): Partial<EditableFields> {
  const { poc, ...rest } = patch;
  const resolvedPocBlocks =
    patch.pocBlocks !== undefined ? patch.pocBlocks : currentPocBlocks;

  if (typeof poc !== 'string' || !poc.trim() || !resolvedPocBlocks?.length) {
    return patch;
  }

  const lastBlock = resolvedPocBlocks[resolvedPocBlocks.length - 1];
  const alreadyAppended =
    lastBlock?.type === 'narrative' && lastBlock.content === poc;

  return {
    ...rest,
    pocBlocks: alreadyAppended
      ? resolvedPocBlocks
      : [...resolvedPocBlocks, { type: 'narrative', content: poc }],
  };
}
